// ?use_ios_ui (2026-10-17) — a pinch as iOS reports one: begin at the
// midpoint, then a scale CUMULATIVE since the fingers landed, then end.
// The shipped touch gestures report per-move deltas instead; this reads
// the same live pointer set and is used only under the flag.

import type { ScreenPoint } from '@/ar/wheel-renderer'

export interface TPinchTrack {
  readonly startDistance: number
}

export type TPinchEvent =
  | { readonly kind: 'begin'; readonly midpoint: ScreenPoint }
  | { readonly kind: 'change'; readonly scale: number }
  | { readonly kind: 'end' }

export function trackPinch(
  track: TPinchTrack | null,
  pointers: ReadonlyMap<number, ScreenPoint>,
): { track: TPinchTrack | null; event: TPinchEvent | null } {
  if (pointers.size !== 2) {
    return track == null ? { track: null, event: null } : { track: null, event: { kind: 'end' } }
  }
  const [a, b] = Array.from(pointers.values()) as [ScreenPoint, ScreenPoint]
  const distance = Math.hypot(a.x - b.x, a.y - b.y)
  if (track == null) {
    if (distance <= 0) return { track: null, event: null }
    return {
      track: { startDistance: distance },
      event: { kind: 'begin', midpoint: { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 } },
    }
  }
  return { track, event: { kind: 'change', scale: distance / track.startDistance } }
}
